export const FONTS = [
  {
    name: 'Roboto',
    value: 'Roboto',
  },
  {
    name: 'Times New Roman',
    value: 'Times New Roman',
  },
  {
    name: 'Arial',
    value: 'Arial',
  },
];
